(function () {
  'use strict';

  angular.module('app').component('transportationCostsAndPrices', transportationCostsAndPrices());

  function transportationCostsAndPrices() {
    return {
      bindings: {
        transportation: '<',
        onCostsAndPricesSaved: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: TransportationCostsAndPricesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation/components/transportation-costs-and-prices/transportation-costs-and-prices.component.html',
    };
  }

  TransportationCostsAndPricesComponent.$inject = ['zoneService'];

  function TransportationCostsAndPricesComponent(zoneService) {
    const vm = this;

    vm.$onInit = function () {
      vm.showCosts = true;
      vm.showPrices = true;

      // Initilizers
      getZonesByProduct();
    };

    vm.onSeasonSelected = function (season) {
      vm.seasonSelected = season;
    };

    vm.onProductCostsAndPricesSaved = function (associated_providers) {
      vm.onCostsAndPricesSaved({ associated_providers: associated_providers });
    };

    // Get active zones by product location
    function getZonesByProduct() {
      if (!vm.transportation.departure_location_id) {
        vm.zonesByProduct = [];
        return;
      }

      if (vm.zonesByProduct) {
        return;
      }

      let filterCriteria = {
        get: 'by_locations',
        'location_ids[]': [
          vm.transportation.departure_location_id,
          vm.transportation.arrival_location_id,
        ],
        // lang: vm.defaultLanguage,
        lang: vm.userLanguageCode,
        skip_check_role: true,
      };

      zoneService.getZones(filterCriteria).subscribe((response) => {
        vm.zonesByProduct = response;
      });
    }
  }
})();
